// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ONFWE","textarea":"styles_textarea__37cas"};